import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { styled } from '@mui/system';

const withSnackbar = (ChildrenContent, options) => {
  // Custom snackBar content style
  const MySnackbar = styled(Snackbar)(() => {
    return options?.style ? {'& .MuiSnackbarContent-root': options.style } : {};
  });

  // Custom snackBar close button
  const MyStyledButton = styled(IconButton)(() => {
    return options?.closeStyle ? options.closeStyle : {};
  });

  // Create snackbar
  const SetSnackbar = props => {
    const [setting, setSetting] = useState({
      open: false,
      msg: ''
    });

    // Open snackbar
    const openSnackbar = (msg = '') => {
      if (typeof msg === 'string') {
        setSetting({
          open: true,
          msg
        });
      };
    }

    // Close snackbar
    const handleClose = () => {
      setSetting({...setting, open: false});
    }
    return (
      <>
        <ChildrenContent {...props} openSnackbar={openSnackbar} />

          <MySnackbar
            anchorOrigin={{
              vertical: options?.position?.vertical || 'bottom',
              horizontal: options?.position?.horizontal || 'center',
            }}
            autoHideDuration={5000}
            open={setting.open}
            onClose={handleClose}
            message={setting.msg}
            TransitionComponent={Slide}
            action={
              <MyStyledButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </MyStyledButton>
            }
          />
       
      </>
    )
  }

  return SetSnackbar;
}

export default withSnackbar;